(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/banner-blur-slider/assets/javascripts/banner-blur-slider.js') >= 0) return;  svs.modules.push('/widgets/banner-blur-slider/assets/javascripts/banner-blur-slider.js');

'use strict';

svs.widget = svs.widget || {};
svs.widget.banner_blur_slider = svs.widget.banner_blur_slider || {};
svs.widget.banner_blur_slider.init = svs.banner_groups.banner_blur_slider.init;

 })(window);